import * as React from 'react';
import {StyleSheet, View} from 'react-native';
import {Text} from 'react-native';
import DiscountLine from 'src/components/screens/scanAndPay/DiscountLine';
import Localized from 'src/constants/AppStrings';
import {scanAndPayTemplate as tpl} from './templates/scanandPayThemeHelper';
import Styles from 'src/components/Styles';

interface Props {
  points?: number;
  isReward?: boolean;
}

const {rewardDiscountLabelColor} = tpl;

const RewardDiscount = (props: Props) => {
  if (props?.points < 0 && props.isReward) {
    return (
      <View style={styles.discountItem}>
        <DiscountLine
          discount={{
            displayName: Localized.Labels.rewards_redemption,
          }}
          color={rewardDiscountLabelColor}
        />
        <Text style={styles.price}>{Localized.Labels.free}</Text>
      </View>
    );
  }
  return null;
};

export default RewardDiscount;

const styles = StyleSheet.create({
  discountItem: {
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'space-between',
  },
  price: {
    fontWeight: '400',
    fontSize: tpl.cartItemPrice,
    fontFamily: tpl.textFontFamily,
    color: tpl.rewardDiscountTextColor,
  },
});
